import React from 'react';
import { useSelector } from 'react-redux';

import SALES from '../../../../../../../../../../api/ressources/SellerApp/sales';

const DiagsPartner = ({ hasDiags, needsDiags, setNeedsDiags }) => {
  const { sale } = useSelector((state) => state.sellerSales);
  const { photoPacks: { can_use_lightshop_pack_max } } = useSelector((state) => state.sellerPhotoMeetings);
  
  if (hasDiags !== false || can_use_lightshop_pack_max) return null
  
  const handleChange = (value) => {
    setNeedsDiags(value)
    SALES.updateSale(sale.id, { needs_diagnostics: value })
  }
  return (
    <div className='flex flex-col gap-6 mt-6'>
      <p className='h2'>Souhaitez-vous recevoir un devis de la part de notre diagnostiqueur partenaire ?</p>
      
      <div className='flex flex-col gap-3'>
        <div className={`flex items-center gap-3 border ${needsDiags === true ? 'border-ih-blue' : 'border-ih-blue-30'} rounded-2xl p-5 bg-white cursor-pointer`} onClick={() => handleChange(true)}>
          <div className='w-max'>
            <div className={`w-6 h-6 rounded-full border border-ih-blue-30 ${needsDiags === true && 'bg-ih-blue'}`}></div>
          </div>
          <p className='text-sm font-semibold'>Oui, je suis intéressé(e)</p>
        </div>

        <div className={`flex items-center gap-3 border ${needsDiags === false ? 'border-ih-blue' : 'border-ih-blue-30'} rounded-2xl p-5 bg-white cursor-pointer`} onClick={() => handleChange(false)}>
          <div className='w-max'>
            <div className={`w-6 h-6 rounded-full border border-ih-blue-30 ${needsDiags === false && 'bg-ih-blue'}`}></div>
          </div>
          <p className='text-sm font-semibold'>Non, je préfère choisir mon propre diagnostiqueur</p>
        </div>
      </div>
    </div>
  )
}

export default DiagsPartner;
